const HOME_OWNERS_BASE_URL = "/home-owners"

export const AUTH_PAGE_ROUTE = {
    login: "/", // Unified entry point (replaces old /login route)
    signupInto:"/email-registration?role=homeowner", // Redirects to email-registration for homeowners
    signupStep1:"/email-registration", // Legacy - kept for backward compatibility
    signupStepForms:"/email-registration", // Legacy - kept for backward compatibility
    loginByOtop:"/otp-login",
    registration:'/homeAuth',
     google: {
        base: `/auth/google`,
        callback: `/auth/google/callback`,
    },
    emailRegistration: "/email-registration",
    singUp: "/email-registration", // Alias for backward compatibility
    forgotPassword: "/forgot-password",
    verification: "/verification",
    successfullyCreated: "/successfully-created",
    successfullySent: "/successfully-sent",
    resetPassword: "/reset-password",
} as const

export const AUTH_PAGE_ROUTE_LIST = Object.values(AUTH_PAGE_ROUTE)

export const DASHBOARD_ROUTE = {
    dashboard: "/homeowners",
    map: "/homeowners",
    hoAddress: "/homeowners",
    workOrders: "/work-orders",
    createWorkOrders: "/work-orders/create",
    homeOwners: "/home-owners",
    planning: "/homeowners",
    reports: "/reports",
    members: "/members",
    messages: "/messages",
    settings: "/settings",
    admin: "/admin",
    volunteers: "/volunteers",
    partners: "/partners",
    profile: "/profile",
    base: "/base",
    toolsSupplies: "/tools-supplies",
    migration: "/migration",
} as const

export const WORK_ORDERS_ROUTES = {
    workScopeDetails: "/work-orders/scope",
    edit: (workOrderId: string | number) => `/work-orders/edit/${workOrderId}`,
    details: (workOrderId: string | number) => `/work-orders/${workOrderId}`,
}

export const SUPPORTER_ROUTES = {
    landingpage: "/supporter-registration",
    register:'/supporter-registration/register',
    volunteer:'/supporter-registration/volunteer'
}


export const HOME_OWNERS_ROUTES = {
    base: `${HOME_OWNERS_BASE_URL}`,
    create: `${HOME_OWNERS_BASE_URL}/create`,
    details: (homeOwnerId: string | number) =>
        `${HOME_OWNERS_BASE_URL}/${homeOwnerId}`,
    home: {
        base: `${HOME_OWNERS_BASE_URL}/home`,
        details: (homeOwnerId: string | number) =>
        `${HOME_OWNERS_BASE_URL}/home/${homeOwnerId}`,
    },
} as const

const HOMEOWNERS_BASE_URL = "/homeowners"

export const HOMEOWNERS_ROUTES = {
    base: `${HOMEOWNERS_BASE_URL}`,
    create: `${HOMEOWNERS_BASE_URL}/create`,
    map: `${HOMEOWNERS_BASE_URL}?tab=map`,
    details: (homeOwnerId: string | number) =>
        `${HOMEOWNERS_BASE_URL}/${homeOwnerId}`,
    home: {
        base: `${HOMEOWNERS_BASE_URL}/home`,
        details: (homeOwnerId: string | number) =>
            `${HOMEOWNERS_BASE_URL}/home/${homeOwnerId}`,
    },
} as const

const BASE_BASE_URL = "/base"

export const BASE_ROUTES = {
    base: `${BASE_BASE_URL}`,
    admin: `${BASE_BASE_URL}/admin`,
} as const

export const BASIC_ROUTE = {
    home: "/",
} as const

export const PAGE_ROUTES = {
    ...AUTH_PAGE_ROUTE,
    ...DASHBOARD_ROUTE,
    ...SUPPORTER_ROUTES,
    ...BASIC_ROUTE,
}
